<template>
  <g class="setstar">
    <circle
      v-for="(setstar, index) in visualizationSetstars"
      :key="index"
      :cx="setstar.positionX"
      :cy="-setstar.positionY"
      :fill="fill(Math.round(setstar.setstar))"
      r="1.65"
      fill-opacity="0.7"
    />
  </g>
</template>

<script>
export default {
  data() {
    return {
      setstars: [34, 33, 32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14],
    };
  },
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    visualizationSetstars: (vm) => vm.spots.filter((spot) => vm.isNotRestroom(spot)).map((spot) => vm.buildSetstarBy(spot)),
    fill: ({ setstars }) => (currentValue) => {
      const roundValue = Math.round(currentValue);
      let colorId = 1;

      setstars.forEach((value, index) => {
        if (value === roundValue) {
          colorId = index + 1;
        } else if (roundValue > setstars[0]) {
          colorId = 1;
        } else if (roundValue < setstars.slice(-1)[0]) {
          colorId = setstars.length;
        }
      });

      return `url(#setstar-color-${colorId})`;
    },
  },
  methods: {
    isNotRestroom(spot) {
      return spot.spotState && spot.type.indexOf('Restroom') < 0;
    },
    buildSetstarBy(spot) {
      return {
        positionX: spot.positionX,
        positionY: spot.positionY,
        setstar: spot.spotState.setstar || 0,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// setstar.vue?38bfc3a7